import { Icon } from '@chakra-ui/react';

export const SubordinateBold = (props) => (
  <Icon viewBox="0 0 24 24" boxSize="16px" color="icon.g1" {...props}>
    <path
      d="M5.5 16.0059C5.5 14.349 6.84315 13.0059 8.5 13.0059H12.5C14.1569 13.0059 15.5 14.349 15.5 16.0059V18.9412C15.5 18.9742 15.4732 19.001 15.4402 19.001H5.55981C5.52678 19.001 5.5 18.9742 5.5 18.9412V16.0059Z"
      stroke="currentColor"
      strokeWidth="2"
      fill="transparent"
    />
    <path
      d="M12.7859 7.42648C12.7859 8.76601 11.6991 9.85296 10.3573 9.85296C9.01544 9.85296 7.92871 8.76601 7.92871 7.42648C7.92871 6.08695 9.01544 5 10.3573 5C11.6991 5 12.7859 6.08695 12.7859 7.42648Z"
      stroke="currentColor"
      strokeWidth="2"
      fill="transparent"
    />
    <path
      d="M19.5002 6.63125C19.5002 6.73125 19.5002 6.93125 19.4002 7.03125C19.3002 7.13125 19.2002 7.23125 19.1002 7.23125C19.0002 7.23125 18.9002 7.13125 18.8002 7.03125L17.5002 5.73125V9.53125C17.5002 9.83125 17.3002 10.0312 17.0002 10.0312C16.7002 10.0312 16.5002 9.83125 16.5002 9.53125V5.73125L15.5002 6.93125C15.4002 7.03125 15.2002 7.13125 15.0002 7.03125C14.8002 7.03125 14.7002 6.83125 14.7002 6.63125C14.7002 6.43125 14.7002 6.23125 14.8002 6.13125L16.7002 4.13125C16.7002 4.13125 16.7002 4.13125 16.8002 4.03125H16.9002C17.0002 4.03125 17.0002 4.03125 17.1002 4.03125C17.2002 4.03125 17.2002 4.03125 17.3002 4.03125L17.4002 4.13125H17.5002L19.4002 6.13125C19.5002 6.33125 19.5002 6.43125 19.5002 6.63125Z"
      fill="currentColor"
    />
  </Icon>
);
